// The study calendar's two enhancements (study_calendars/show).
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside chosen_paper_picker.js. The page works without
// it: the feed link sits in a readonly field a person can select, and the
// class-pace list is a plain list of radio buttons. So both controls ship
// `hidden` and this only reveals what it can drive.
//
// - [data-calendar-copy] copies the value of the field it names (an id) and
//   says so on the button for two seconds.
// - [data-pace-filter] narrows the class-pace list to lines whose text
//   matches, hiding the headings left with nothing under them.

const COPIED_FOR_MS = 2000;

function copy(button) {
  const field = document.getElementById(button.dataset.calendarCopy);
  if (!field) return;

  const done = () => {
    const label = button.dataset.label || button.textContent;
    button.dataset.label = label;
    button.textContent = "Copied";
    setTimeout(() => { button.textContent = label; }, COPIED_FOR_MS);
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(field.value).then(done, () => field.select());
  } else {
    field.select();
  }
}

function filter(input) {
  const list = document.querySelector("[data-pace-list]");
  if (!list) return;

  const query = input.value.trim().toLowerCase();
  let heading = null;
  let headingHasMatch = false;
  const settle = () => { if (heading) heading.hidden = !headingHasMatch; };

  Array.from(list.children).forEach((node) => {
    if (node.matches("[data-pace-line]")) {
      const match = !query || node.textContent.toLowerCase().includes(query);
      node.hidden = !match;
      if (match) headingHasMatch = true;
    } else {
      settle();
      heading = node;
      headingHasMatch = false;
    }
  });
  settle();
}

function init() {
  document.querySelectorAll("[data-calendar-copy], [data-pace-filter]").forEach((node) => {
    node.hidden = false;
  });
}

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-calendar-copy]");
  if (!button) return;
  event.preventDefault();
  copy(button);
});

document.addEventListener("input", (event) => {
  if (event.target.matches("[data-pace-filter]")) filter(event.target);
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
